// Journal Start Modal Messages Configuration
// Each journal section can have a custom message and estimated time

export const JOURNAL_START_MESSAGES = {
    'self-assessment': {
        title: 'Self-Assessment Journal',
        message: `Get comfortable, relax and set aside time for yourself`,
        estimatedTime: '15 - 30 minutes'
    },
    //     'current-health': {
    //         title: 'Current Health Journal',
    //         message: `Document your current health status.
    // This section takes approximately 10-15 minutes.
    // You have 7 days to complete before it locks.`,
    //         estimatedTime: '10 - 15 minutes'
    //     },
    'reflection': {
        title: 'Reflection Journal',
        message: `Take your time; you’re worth it`,
        estimatedTime: '15 - 30 minutes'
    },
    'transformation': {
        title: 'Transformation Journal',
        message: `Your habits can build you up`,
        estimatedTime: '15 - 30 minutes'
    },
    //     'progress': {
    //         title: 'Progress Journal',
    //         message: `Review and document your progress.
    // This section takes approximately 10-15 minutes.
    // You have 7 days to complete before it locks.`,
    //         estimatedTime: '10 - 15 minutes'
    //     },
    'checkin-01': {
        title: 'Check-In 1',
        message: `Relax your shoulders, it's time for you again`,
        estimatedTime: '15 - 30 minutes'
    },
    'checkin-02': {
        title: 'Check-In 2',
        message: `Take a deep breathe, you have another opportunity to take care of yourself again`,
        estimatedTime: '15 - 30 minutes'
    },
    'checkin-03': {
        title: 'Check-In 3',
        message: `Art takes time`,
        estimatedTime: '15 - 30 minutes'
    },
    'checkin-04': {
        title: 'Check-In 4',
        message: `Grab a warm drink…`,
        estimatedTime: '15 - 30 minutes'
    },
    'checkin-05': {
        title: 'Check-In 5',
        message: `You know the drill...`,
        estimatedTime: '15 - 30 minutes'
    },
    'checkin-06': {
        title: 'Check-In 6',
        message: `Well done!!! And welcome back for the last entry`,
        estimatedTime: '15 - 30 minutes'
    },
    //     'evaluation': {
    //         title: 'Evaluation Journal',
    //         message: `Final evaluation of your health journey.
    // This comprehensive section takes 20-30 minutes.
    // You have 7 days to complete before it locks.`,
    //         estimatedTime: '20 - 30 minutes'
    //     }
};

// Helper function to get modal config for a journal section
export const getJournalStartConfig = (section) => {
    return JOURNAL_START_MESSAGES[section] || {
        title: 'Journal Entry',
        // message: `Take your time to complete this section.
        // You have 7 days to fill this before it locks.`,
        message: `Take your time to complete this section.`,
        estimatedTime: '10 - 20 minutes'
    };
};

// Locking period constants (temporarily disabled in frontend)
// export const JOURNAL_LOCK_DAYS = 7;
// export const JOURNAL_LOCK_MS = JOURNAL_LOCK_DAYS * 24 * 60 * 60 * 1000;
